export default __webpack_public_path__ + "locales/ar-SA/Common.json?hash=344f9e435d50ed26e0ab933a5ddc587b";